'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.weekAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/weekAfter.js
// module id = 747
// module chunks = 0